'use client';

import { type ParsedUrlQuery } from 'querystring';
import { useEffect } from 'react';
import { CarvanaButtons, SocialMediaButtons } from '@/share/Buttons';
import Description from '@/share/Description';
import VideoPlayer from '@/share/Video';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { Wrapper } from './Layout.styles';

type OwnProps = {
  assetId: string;
  searchParams: ParsedUrlQuery;
};

export default function Layout({ assetId, searchParams = {} }: OwnProps) {
  const trackEvent = useTrackEvent();
  const isSocialMediaUser = 'utm_source' in searchParams;

  useEffect(() => {
    trackEvent('Page load land event', {
      assetId,
      url: window.location.href
    });
  }, [assetId, trackEvent]);

  return assetId ? (
    <Wrapper>
      <Description shouldDisplayAssetOwnerLayout={!isSocialMediaUser} />
      <VideoPlayer assetId={assetId} />
      {isSocialMediaUser ? (
        <CarvanaButtons />
      ) : (
        <SocialMediaButtons assetId={assetId} />
      )}
    </Wrapper>
  ) : null;
}
